/* global axios */
import AsteriskApiClient from './index';

class TransferNotificationsAPI extends AsteriskApiClient {
  constructor() {
    super('transfer_notifications');
  }

  // POST /api/v1/accounts/:account_id/asterisk/transfer_notifications
  // Notify target agent about incoming transfer with caller info
  create(data) {
    return axios.post(this.url, data);
  }
}

export default new TransferNotificationsAPI();
